"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateUserInteractions = exports.storeAsperaConnectId = exports.loadWorkgroups = exports.loadUsers = exports.loadUserInteractions = exports.loadInternalUsers = exports.getRemoteSources = exports.storeAsperaConnectIdSuccess = exports.queryUsers = exports.loadWorkgroupsSuccess = exports.loadUserInteractionsSuccess = exports.loadInternalUsersSuccess = exports.getRemoteSourcesSuccess = void 0;
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* Package Imports */
var axios_1 = __importDefault(require("axios"));
var lodash_1 = __importDefault(require("lodash"));
var lz_string_1 = __importDefault(require("lz-string"));
var typesafe_actions_1 = require("typesafe-actions");
/* Blast Imports */
var UsersApi = __importStar(require("@app/services/api/users"));
var constants_1 = require("@app/shared/constants");
var log_1 = __importDefault(require("@app/shared/log"));
var createAction = typesafe_actions_1.deprecated.createAction;
/* Action Creators - begin */
exports.getRemoteSourcesSuccess = createAction('@@users/GET_REMOTE_SOURCES', function (resolve) { return function (sources) { return resolve(sources); }; });
exports.loadInternalUsersSuccess = createAction('@@users/LOAD_INTERNAL_USERS_SUCCESS', function (resolve) { return function (users) { return resolve(users); }; });
exports.loadUserInteractionsSuccess = createAction('@@users/LOAD_USER_INTERACTIONS_SUCCESS', function (resolve) { return function (users) { return resolve(users); }; });
exports.loadWorkgroupsSuccess = createAction('@@users/LOAD_WORKGROUPS_SUCCESS', function (resolve) { return function (users) { return resolve(users); }; });
exports.queryUsers = createAction('@@users/QUERY', function (resolve) { return function (term) { return resolve(term); }; });
exports.storeAsperaConnectIdSuccess = createAction('@@users/STORE_ASPERA_CONNECT_ID', function (resolve) { return function (connectId, connectVersion) { return resolve({ connectId: connectId, connectVersion: connectVersion }); }; });
/* Action Creators - end */
/* User's Action Functions - begin */
var getRemoteSources = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var remoteSources, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, UsersApi.getUsersRemoteSources()];
                case 1:
                    remoteSources = _a.sent();
                    dispatch(exports.getRemoteSourcesSuccess(remoteSources));
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    log_1.default.error("Failed to get user's remote sources " + JSON.stringify(error_1));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.getRemoteSources = getRemoteSources;
var loadInternalUsers = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var internalUsers, compressedUserData, decompressedUserData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!sessionStorage.getItem(constants_1.BLAST_USERS_KEY)) return [3 /*break*/, 2];
                    return [4 /*yield*/, UsersApi.getUsers()];
                case 1:
                    internalUsers = _a.sent();
                    internalUsers = lodash_1.default.uniqBy(internalUsers, function (u) { return u.email; });
                    compressedUserData = lz_string_1.default.compressToUTF16(JSON.stringify(internalUsers));
                    sessionStorage.setItem(constants_1.BLAST_USERS_KEY, compressedUserData);
                    return [3 /*break*/, 3];
                case 2:
                    decompressedUserData = lz_string_1.default.decompressFromUTF16(sessionStorage.getItem(constants_1.BLAST_USERS_KEY));
                    internalUsers = (decompressedUserData) ? JSON.parse(decompressedUserData) : [];
                    _a.label = 3;
                case 3:
                    dispatch(exports.loadInternalUsersSuccess(internalUsers));
                    return [2 /*return*/];
            }
        });
    }); };
};
exports.loadInternalUsers = loadInternalUsers;
var loadUserInteractions = function (forceRefresh) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var userInteractions;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(forceRefresh || !sessionStorage.getItem(constants_1.BLAST_INTERACTIONS_KEY))) return [3 /*break*/, 2];
                    return [4 /*yield*/, UsersApi.getUsersInteractions()];
                case 1:
                    userInteractions = _a.sent();
                    userInteractions = lodash_1.default.uniqBy(userInteractions, function (u) { return u.email; });
                    sessionStorage.setItem(constants_1.BLAST_INTERACTIONS_KEY, JSON.stringify(userInteractions));
                    return [3 /*break*/, 3];
                case 2:
                    userInteractions = JSON.parse(sessionStorage.getItem(constants_1.BLAST_INTERACTIONS_KEY));
                    _a.label = 3;
                case 3:
                    dispatch(exports.loadUserInteractionsSuccess(userInteractions));
                    return [2 /*return*/];
            }
        });
    }); };
};
exports.loadUserInteractions = loadUserInteractions;
var loadUsers = function (shouldLoadInternalUsers) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var dispatchActions;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatchActions = [
                        dispatch(exports.loadUserInteractions()),
                        dispatch(exports.loadWorkgroups())
                    ];
                    if (shouldLoadInternalUsers) {
                        dispatchActions.push(dispatch(exports.loadInternalUsers()));
                    }
                    return [4 /*yield*/, Promise.all(dispatchActions)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
};
exports.loadUsers = loadUsers;
var loadWorkgroups = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var workgroupUsers;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!sessionStorage.getItem(constants_1.BLAST_WORKGROUPS_KEY)) return [3 /*break*/, 2];
                    return [4 /*yield*/, UsersApi.getUsersWorkgroups()];
                case 1:
                    workgroupUsers = _a.sent();
                    workgroupUsers = lodash_1.default.uniqBy(workgroupUsers, function (u) { return u.user.email; });
                    sessionStorage.setItem(constants_1.BLAST_WORKGROUPS_KEY, JSON.stringify(workgroupUsers));
                    return [3 /*break*/, 3];
                case 2:
                    workgroupUsers = JSON.parse(sessionStorage.getItem(constants_1.BLAST_WORKGROUPS_KEY));
                    _a.label = 3;
                case 3:
                    dispatch(exports.loadWorkgroupsSuccess(workgroupUsers));
                    return [2 /*return*/];
            }
        });
    }); };
};
exports.loadWorkgroups = loadWorkgroups;
var storeAsperaConnectId = function (connectId, connectVersion) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var updatedJwt, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, UsersApi.storeAsperaConnectId(connectId, connectVersion)];
                case 1:
                    updatedJwt = _a.sent();
                    dispatch(exports.storeAsperaConnectIdSuccess(connectId, connectVersion));
                    sessionStorage.setItem(constants_1.JWT_STORAGE_KEY, updatedJwt);
                    axios_1.default.defaults.headers.common.authorization = "Bearer " + updatedJwt;
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    log_1.default.error("Failed to store user's connect id: " + JSON.stringify(error_2));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.storeAsperaConnectId = storeAsperaConnectId;
/**
 * Updates the list of a user's interactions, with a list of recipients from a newly created package
 * This is an alternative, w/o any api calls, to using "loadUserInteractions(true)"
 */
var updateUserInteractions = function (recipients) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var userInteractions, _i, recipients_1, r, contact;
        return __generator(this, function (_a) {
            if (sessionStorage.getItem(constants_1.BLAST_INTERACTIONS_KEY)) {
                // Get existing user interactions from the session storage
                userInteractions = JSON.parse(sessionStorage.getItem(constants_1.BLAST_INTERACTIONS_KEY));
            }
            else {
                userInteractions = [];
            }
            // Convert recipients into BlastContacts and add to user interactions
            for (_i = 0, recipients_1 = recipients; _i < recipients_1.length; _i++) {
                r = recipients_1[_i];
                contact = {
                    email: r.user.userEmail,
                    isInternal: r.user.isInternal,
                    name: r.user.firstName + " " + r.user.lastName
                };
                userInteractions.push(contact);
            }
            // Remove any duplicate emails from user interactions
            userInteractions = lodash_1.default.uniqBy(userInteractions, function (u) { return u.email; });
            // Update user interactions in session storage
            sessionStorage.setItem(constants_1.BLAST_INTERACTIONS_KEY, JSON.stringify(userInteractions));
            dispatch(exports.loadUserInteractionsSuccess(userInteractions));
            return [2 /*return*/];
        });
    }); };
};
exports.updateUserInteractions = updateUserInteractions;
/* User's Action Functions - end */
